import { ToolInfo } from "./types";

export const tools: ToolInfo[] = [
  {
    id: "tgb",
    name: "Telegram Bulk Sender",
    image: "/other-tools/tg-bulk-sender.png",
    website:
      "https://chromewebstore.google.com/detail/telegram-bulk-sender/hmbjoobnolmppflmppjgkpblglbmkemo?utm_source=item-share-cb",
    extensionUrl:
      "https://chromewebstore.google.com/detail/telegram-bulk-sender/hmbjoobnolmppflmppjgkpblglbmkemo?utm_source=item-share-cb",
    purchaseUrl: "https://tg-hub.com/tg-sender-telegram-bulk-sender/#pricing",
    contactSupportUrl:
      "https://chromewebstore.google.com/detail/telegram-bulk-sender/hmbjoobnolmppflmppjgkpblglbmkemo?utm_source=item-share-cb",
    miniDes: "Automate mass messaging.",
  },
  {
    id: "tgv",
    name: "Telegram Video Downloader",
    image: "/other-tools/tg-video-downloader.png",
    website:
      "https://chromewebstore.google.com/detail/premium-telegram-video-do/fcfmhkgnglllagldahcfpnocepofmmao",
    extensionUrl:
      "https://chromewebstore.google.com/detail/premium-telegram-video-do/fcfmhkgnglllagldahcfpnocepofmmao",
    purchaseUrl: "https://tg-hub.com/telegram-video-downloader/#pricing",
    contactSupportUrl:
      "https://chromewebstore.google.com/detail/premium-telegram-video-do/fcfmhkgnglllagldahcfpnocepofmmao",
    miniDes: "Save restricted media.",
  },
  {
    id: "tgt",
    name: "Telegram Web Translator",
    image: "/other-tools/tg-translator.png",
    website:
      "https://chromewebstore.google.com/detail/telegram-web-translator/mcemogfodjmgbhahncfibpgnmbcmiimh",
    extensionUrl:
      "https://chromewebstore.google.com/detail/telegram-web-translator/mcemogfodjmgbhahncfibpgnmbcmiimh",
    purchaseUrl: "https://www.lang-translator.com/translator-for-telegram#pricing",
    contactSupportUrl:
      "https://chromewebstore.google.com/detail/telegram-web-translator/mcemogfodjmgbhahncfibpgnmbcmiimh",
    miniDes: "Auto-translate conversations.",
  },
];

export const teleTools = [
  {
    name: "Privacy Extension",
    miniDes: "Hide online & typing status.",
    img: "/other-tools/tg-privacy.png",
    url: "https://chromewebstore.google.com/detail/privacy-extension-for-tel/fohlnllcooiliiibhnnlamcmjcaanoci",
  },
];
